class LocalizationForm extends HTMLElement {
  #countrySelect = this.querySelector('#localization-country');
  #countryOptions = this.#countrySelect.querySelectorAll('[data-select-list] button');

  #languageSelect = this.querySelector('#localization-language');

  #languageControl = this.#languageSelect?.querySelector('button');
  #languageList = this.#languageControl.ariaControlsElements[0];
  #languageOptions = this.#languageList.querySelectorAll('button');

  connectedCallback() {
    this.#countryOptions.forEach((option) => {
      option.addEventListener('click', (event) => this.#onCountryChange(event));
    });

    this.#languageOptions.forEach((option) => {
      option.addEventListener('click', (event) => this.#onLanguageChange(event));
    });
  }

  #onCountryChange({ currentTarget }) {
    this.#countrySelect.close();
    const availableLanguages = currentTarget.dataset.availableLanguages.split(',');

    this.#languageOptions.forEach((option) => {
      option.removeAttribute('data-selected');
      option.classList.toggle('hidden', !availableLanguages.includes(option.dataset.value));
    });

    this.#languageList.querySelector('button:not(.hidden)').setAttribute('data-selected', '');

    this.#languageSelect.initSelectedOption();
  }

  #onLanguageChange() {
    this.#languageSelect.close();
  }
}

customElements.define('localization-form', LocalizationForm);
